// eslint-disable-next-line no-shadow
enum TaskStatus {
    IDLE = 'IDLE',
    IN_PROGRESS = 'IN_PROGRESS',
    CANCELLED = 'CANCELLED',
    FINISHED = 'FINISHED',
}

export default TaskStatus;
